import { render, staticRenderFns } from "./ModalMemoMath.vue?vue&type=template&id=6279d178&scoped=true&lang=pug&"
import script from "./ModalMemoMath.vue?vue&type=script&lang=ts&"
export * from "./ModalMemoMath.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMemoMath.vue?vue&type=style&index=0&id=6279d178&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6279d178",
  null
  
)

export default component.exports